export enum RecurringReviewSectionStatus {
  Verified = 0,
  Missing = 1,
  Override = 2,
}
